import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { fromEvent, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { UnsubscribeService } from '@core/services/unsubscribe.service';

@Component({
  selector: 'gcc-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  exportAs: 'gccSearchInput',
  standalone: false
})
export class SearchInputComponent implements AfterViewInit {
  @ViewChild('search', { read: ElementRef }) public input: ElementRef<HTMLInputElement>;

  @Input() public value = '';
  @Input() public debounceTime = 300;
  @Input() public placeholder = 'Search';

  @Output() public apply: EventEmitter<string> = new EventEmitter();
  @Output() public valueChange: EventEmitter<string> = new EventEmitter();

  constructor(private unsubscribe$: UnsubscribeService) {}

  public ngAfterViewInit(): void {
    const input$ = fromEvent(this.input.nativeElement, 'input').pipe(
      map((e: InputEvent) => (e.target as HTMLInputElement).value)
    );
    const change$ = fromEvent(this.input.nativeElement, 'change').pipe(
      map((e: InputEvent) => (e.target as HTMLInputElement).value)
    );
    merge(input$, change$)
      .pipe(distinctUntilChanged(), debounceTime(this.debounceTime), takeUntil(this.unsubscribe$))
      .subscribe(value => {
        this.value = value;
        this.valueChange.emit(this.value);
      });
  }

  public handleApply(value: string) {
    this.value = value;
    this.apply.emit(value);
  }

  public clear() {
    this.value = '';
    this.valueChange.emit('');
  }
}
